import { db, functions } from './firebase-config.js';
import videoConference from './video-conference.js';

const BookingSystem = {
    // Deprecated - bookings now handled through Cal.com
    async requestSession(seekerId, helperId, slotId, sessionData) {
        console.warn('BookingSystem.requestSession is deprecated. Use Cal.com for bookings.');
        return { success: false, error: 'Please use Cal.com to book sessions. Click the "Schedule a Free Session" button on the helper\'s profile.' };
    },
    
    async getUserBookings(userId, role = 'seeker') {
        const field = role === 'seeker' ? 'seekerId' : 'helperId';
        const snapshot = await db.collection('bookings')
            .where(field, '==', userId)
            .orderBy('createdAt', 'desc')
            .get();

        return snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
    },

    // Deprecated - bookings now handled through Cal.com
    async respondToRequest(bookingId, slotId, accept) {
        console.warn('BookingSystem.respondToRequest is deprecated. Bookings are now managed through Cal.com.');
        return { success: false, error: 'Bookings are now managed through Cal.com.' };
    }
};

function generateZoomLink(bookingId) {
    // Use Jitsi Meet for video conferencing
    return videoConference.createMeetingLink(bookingId);
}

export { BookingSystem, generateZoomLink };